import React, { useState } from "react";
import { Table, Input, Button, Modal, Spin, DatePicker } from "antd";
import dayjs from "dayjs";
import { PlusOutlined } from "@ant-design/icons";
import _ from "lodash";

// import CustomCalendar from "../../components/calendar";
import { useDispatch, useSelector } from "react-redux";
import { setStorage } from "./redux/actions";
import moment from "moment";

const { TextArea } = Input;

const HistoryTable = ({ emailsHistoryList, ...rest }) => {
  const { loading } = useSelector((state) => state.emailsManagerReducer);

  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [sortedInfo, setSortedInfo] = useState(rest.sortedInfo || null);
  const [search, setSearch] = useState({});
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);

  const [date, setDate] = useState(null);
  const [dateSent, setDateSent] = useState(null);
  const [datePickerOpened, setDatePickerOpened] = useState(false);
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState({
    subject: "",
    body: "",
    // first_name: "",
    // last_name: "",
    email_receiver_name: "",
    sender: "",
    // response: "",
    dateSent: "",
  });

  const handleSearch = (key, value) => {
    setSearchText((prev) => ({
      ...prev,
      [key]: value.toLowerCase(),
    }));
  };

  const handleViewColumn = (record) => {
    setSelectedRow(record);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };

  const allData = emailsHistoryList
    ?.map((item, index) => ({
      key: index,
      subject: item.subject || "N/A",
      first_name: item?.recipient?.first_name || "",
      last_name: item?.recipient?.last_name || "",
      email_receiver_name: `${item?.recipient?.first_name || ""} ${
        item?.recipient?.last_name || ""
      }`.trim(),
      body: item.body,
      sender: item.sender || "Unknown",
      response: item.response || "No response",
      dateSent: item.sendTimestamp
        ? dayjs(item.sendTimestamp).format("YYYY-MM-DD HH:mm:ss")
        : "N/A",
    }))
    .filter((item) =>
      Object.keys(searchText).every((key) =>
        item[key]?.toString().toLowerCase().includes(searchText[key])
      )
    );

  const commonColumns = [
    {
      title: (
        <div style={{ textAlign: "center", fontWeight: 700, fontSize: "11px" }}>
          ACTIONS
        </div>
      ),
      key: "action",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            icon={<PlusOutlined />}
            className="add-doc-btn class-btn"
            size="middle"
            onClick={() => handleViewColumn(record)}
          >
            View
          </Button>
        </div>
      ),
    },
  ];

  const normalColumns = [
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">DATE SEND</div>
            <div>
              <DatePicker
                onChange={(date, dateString) =>
                  handleSearch("dateSent", dateString)
                }
                allowClear
                style={{ width: "100%" }}
                // placeholder="Select date"
                format="YYYY-MM-DD"
                suffixIcon={null}
              />
            </div>
          </div>
        );
      },
      dataIndex: "dateSent",
      key: "dateSent",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "dateSent" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      align: "left",
      render: (dateSent) => {
        if (!dateSent || dateSent === "N/A") {
          return "N/A";
        }

        return moment
          .utc(dateSent, "YYYY-MM-DD HH:mm:ss.SSS")
          .local()
          .format("DD MMM YYYY hh:mm A");
      },
    },

    // {
    //   title: () => {
    //     return (
    //       <div align="top" className="select-parent-div">
    //         <div className="special-table-header-text">first name</div>
    //         <div>{searchInput("first_name")}</div>
    //       </div>
    //     );
    //   },
    //   dataIndex: "first_name",
    //   key: "first_name",
    //   sorter: true,
    //   sortOrder: sortedInfo?.columnKey === "first_name" && sortedInfo?.order,
    //   ellipsis: true,
    //   width: "20%",
    //   render: (first_name, { _id }) => <div>{first_name}</div>,
    // },

    // {
    //   title: () => {
    //     return (
    //       <div align="top" className="select-parent-div">
    //         <div className="special-table-header-text">last name</div>
    //         <div>{searchInput("last_name")}</div>
    //       </div>
    //     );
    //   },
    //   dataIndex: "last_name",
    //   key: "last_name",
    //   sorter: true,
    //   sortOrder: sortedInfo?.columnKey === "last_name" && sortedInfo?.order,
    //   ellipsis: true,
    //   width: "20%",
    //   render: (last_name, { _id }) => <div>{last_name}</div>,
    // },

    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">Email Receiver Name</div>
            <div>{searchInput("email_receiver_name")}</div>
          </div>
        );
      },
      key: "email_receiver_name",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "email_receiver_name" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      render: (_, { first_name, last_name }) => (
        <div>{`${first_name || ""} ${last_name || ""}`.trim()}</div>
      ),
    },

    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">sender</div>
            <div>{searchInput("sender")}</div>
          </div>
        );
      },
      dataIndex: "sender",
      key: "sender",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "sender" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      render: (sender, { _id }) => <div>{sender}</div>,
    },

    // {
    //   title: () => {
    //     return (
    //       <div align="top" className="select-parent-div">
    //         <div className="special-table-header-text">response</div>
    //         <div>{searchInput("response")}</div>
    //       </div>
    //     );
    //   },
    //   dataIndex: "response",
    //   key: "response",
    //   sorter: true,
    //   sortOrder: sortedInfo?.columnKey === "response" && sortedInfo?.order,
    //   ellipsis: true,
    //   width: "20%",
    //   render: (response, { _id }) => <div>{response}</div>,
    // },
  ];

  const filteredData = allData;

  const htmlToText = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      value={search[key]}
      onChange={(e) => {
        handleSearch(key, e.target.value, debouncedDefaultPageOneCallApi);
      }}
    />
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );

  // const handleTableChange = (pagination, filters, sorter) => {
  //   setSortedInfo(sorter);
  // };


  return (
    <>
      <Spin spinning={loading}>
        <Table
          className="special-table users-manager-table"
          columns={[...normalColumns, ...commonColumns]}
          dataSource={filteredData}
          pagination={{
            pageSize: 10,
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
          }}
        />

        <Modal
          title="Email Details"
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          width={1000}
          style={{ top: 20 }}
        >
          {selectedRow && (
            <>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ fontWeight: "bold" }}>Subject:</label>
                <Input value={selectedRow.subject} readOnly />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <label style={{ fontWeight: "bold" }}>Body:</label>
                <div
                  style={{ height: "auto", pointerEvents: "none" }}
                  dangerouslySetInnerHTML={{ __html: selectedRow.body }}
                  readOnly
                />
              </div>
            </>
          )}
        </Modal>
      </Spin>
    </>
  );
};

export default HistoryTable;
